module.exports = __webpack_public_path__ + "img/gold_lv@2x.4da4d095.png";